module.exports = __webpack_public_path__ + "static/media/COS_PRESENTATION_LOGO.4ea9edb0.png";